export const parseLatLng = (latlngString: string): mapkit.Coordinate | null => {
  try {
    const parseDMS = (input: string): number => {
      const dmsMatch = input.match(/(\d+)°(\d+)'(\d+\.\d+)"?([NSEW])/);
      if (dmsMatch) {
        const degrees = parseFloat(dmsMatch[1]);
        const minutes = parseFloat(dmsMatch[2]);
        const seconds = parseFloat(dmsMatch[3]);
        let decimal = degrees + minutes / 60 + seconds / 3600;
        if (dmsMatch[4] === 'S' || dmsMatch[4] === 'W') decimal = -decimal;
        return decimal;
      }
      const dirMatch = input.match(/([-+]?\d+(\.\d+)?)[°\s]*([NSEW])?/);
      if (dirMatch) {
        const num = parseFloat(dirMatch[1]);
        const dir = dirMatch[3];
        if (dir === 'S' || dir === 'W') return -Math.abs(num);
        return num;
      }
      return NaN;
    };

    const parts = latlngString
      .split(/,\s*|\s+(?=\d)/)
      .map((part) => part.trim());

    const latFinal: number = parseDMS(parts[0]);
    const lngFinal: number = parseDMS(parts[1]);

    if (!isNaN(latFinal) && !isNaN(lngFinal)) {
      return new mapkit.Coordinate(latFinal, lngFinal);
    }

    return null;
  } catch (e) {
    console.log('Error parsing latitude and longitude: ', e);
    return null;
  }
};
